import type { ApiWorkStatusNotification } from '@core/core/api/BffClientSignalR'
import type { ApiProgressNotificationInfo } from '@core/core/api/SeismicImportClientSignalR'
import { tryUpdateUploadFileState, updateMultipartConversionState } from '@core/core/store'
import { isGeoSpaType, isSeismicSpaType } from '@core/core/types'
import { sendSpaForProjectElementAction } from '@core/core/utils'
import { addFileUploadErrorNotification } from '@notifications/actions'
import type { ProjectElementInfo } from 'common/types'

import { checkPoolNames, checkStatusSeismic } from './asserts'

export const getNotifyStatusActions = (data: ApiWorkStatusNotification) => {
  checkPoolNames(data.pool)

  switch (data.pool) {
    case 'GeoImport': {
      return [tryUpdateUploadFileState({ taskId: data.uid, step: 'Uploading', state: data.status })]
    }
    default: {
      return undefined
    }
  }
}

export const getProgressActions = (data: ApiProgressNotificationInfo) => {
  const status = data.status
  checkStatusSeismic(status)
  const checkedProgress = { ...data, status }

  const actions: unknown[] = [updateMultipartConversionState(checkedProgress)]

  if (
    data.taskType !== 'LocalImportSurvey3D' &&
    data.taskType !== 'CrmsImportSurvey3D' &&
    status !== 'Pending' &&
    status !== 'Running'
  ) {
    addFileUploadErrorNotification(checkedProgress)
  }

  return actions
}

export const getElementAddedForSpaActions = (nodes: ProjectElementInfo[]) => {
  const seismicImportElement = nodes.find(i => isSeismicSpaType(i.elementType))

  if (seismicImportElement) {
    return [sendSpaForProjectElementAction('import from file_seismic_loaded', seismicImportElement)]
  }

  const importElement = nodes.find(i => isGeoSpaType(i.elementType === 'map'))
  if (importElement) {
    return [sendSpaForProjectElementAction('import from file_loaded', importElement)]
  }

  return undefined
}
